import { WidgetActionMethod } from '../../WidgetVariant';

enum EmbeddedActionMethod {
  InitiateSimplrChat = 'initiateSimplrChat',
  InitiateChat = 'initiateChat',
}

export type ActionMethod = EmbeddedActionMethod | WidgetActionMethod;

export const ActionMethod = {
  ...EmbeddedActionMethod,
  ...WidgetActionMethod,
};
